import React, {useState} from "react";

const InteractiveSVG = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <svg
            viewBox="0 0 400 400"
            className="w-full h-full transform transition-all duration-500"
            style={{
                transform: isHovered ? 'scale(1.05) rotate(5deg)' : 'scale(1)',
                filter: isHovered ? 'drop-shadow-2xl' : 'drop-shadow-xl'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* SVG content remains the same as in the original code */}
            <defs>
                <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="rgba(59, 130, 246, 0.7)"/>
                    <stop offset="100%" stopColor="rgba(99, 102, 241, 0.7)"/>
                </linearGradient>
            </defs>

            <circle
                cx="200"
                cy="200"
                r="180"
                fill="url(#blueGradient)"
                className="transition-all duration-500"
            />

            <circle
                cx="200"
                cy="200"
                r="160"
                fill="rgba(255,255,255,0.1)"
                className="animate-pulse"
            />
            <circle
                cx="200"
                cy="200"
                r="140"
                fill="rgba(255,255,255,0.05)"
                className="animate-spin-slow"
            />

            <circle
                cx="250"
                cy="150"
                r="30"
                fill="rgba(255,255,255,0.2)"
            />
            <circle
                cx="150"
                cy="250"
                r="20"
                fill="rgba(255,255,255,0.1)"
            />
        </svg>
    );
};

export default InteractiveSVG;